import './partnercard.css';
const PartnerCard = ({ children, heading, subheading }) => {
    return (
        <div className="partner-card">
            <h1 className="heading">{heading}</h1>
            <div className="subheading">{subheading}</div>
            {children}
        </div>
    )
}

export default PartnerCard